import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

/** govuk/components/hint */
export function Hint({ className, children, ...rest }: HTMLAttributes<HTMLSpanElement> & { children: ReactNode }) {
  return (
    <span className={cx('govuk-hint', className)} {...rest}>
      {children}
    </span>
  );
}
